import axios from "axios";
import { API_BASE_URL } from "config/constants";
import {
  getLanguageFromLocalStorage,
  getAccessTokenFromLocalStorage,
  removeUserFromLocalStorage,
  addUserToLocalStorage,
  getRefreshTokenFromLocalStorage
} from "services/LocalStorage/LocalStorage.service";

const customAxiosInterceptor = axios.create({
  baseURL: API_BASE_URL,
});

customAxiosInterceptor.interceptors.request.use((config) => {
  const access_token = getAccessTokenFromLocalStorage();
  const lng = getLanguageFromLocalStorage();

  if (access_token) {
    config.headers["Authorization"] = `Bearer ${access_token}`;
  }
  config.headers["Accept-Language"] = lng;
  return config;
});

customAxiosInterceptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && (error.response.status === 401 || error.response.status == 403) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Attempt to refresh token
        const { data } = await axios.post(`${API_BASE_URL}/auth/refresh`, {
          refresh_token: getRefreshTokenFromLocalStorage(),
        });

        // Update stored tokens
        addUserToLocalStorage(data);

        // Update Authorization header and retry original request
        originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;
        return customAxiosInterceptor(originalRequest);
      } catch (refreshError) {
        // Refresh token failed, probably expired - force logout
        removeUserFromLocalStorage();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export const checkForUnauthorizedResponse = (error, thunkAPI) => {
  if (error.response.status === 401) {
    // thunkAPI.dispatch(clearStore());
    // console.error(error.response.data.message)
    return thunkAPI.rejectWithValue("Unauthorized! Logging Out...");
  }
  return thunkAPI.rejectWithValue(error.response.data.message);
};

export default customAxiosInterceptor;
